import '../css/app.css';

// ── Mailing list form validation ─────────────────────────────────────────────

(function () {
    const form = document.getElementById('subscribe-form');
    if (!form) return;

    const emailInput     = document.getElementById('email');
    const firstNameInput = document.getElementById('firstName');

    function isValidEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim());
    }

    function isValidName(value) {
        return value.trim().length >= 1;
    }

    function setValid(input, errorEl) {
        input.setAttribute('aria-invalid', 'false');
        input.classList.remove('border-red-400', 'ring-2', 'ring-red-400/20');
        input.classList.add('border-green-500', 'ring-2', 'ring-green-500/20');
        errorEl.classList.remove('visible');
    }

    function setInvalid(input, errorEl) {
        input.setAttribute('aria-invalid', 'true');
        input.classList.remove('border-green-500', 'ring-2', 'ring-green-500/20');
        input.classList.add('border-red-400', 'ring-2', 'ring-red-400/20');
        errorEl.classList.add('visible');
    }

    function clearState(input, errorEl) {
        input.setAttribute('aria-invalid', 'false');
        input.classList.remove(
            'border-red-400', 'ring-red-400/20',
            'border-green-500', 'ring-green-500/20',
            'ring-2'
        );
        errorEl.classList.remove('visible');
    }

    function shake(input) {
        input.classList.remove('field-shake');
        void input.offsetWidth;
        input.classList.add('field-shake');
        input.addEventListener('animationend', () => input.classList.remove('field-shake'), { once: true });
    }

    function validateEmailField(showError) {
        const errorEl = document.getElementById('email-error');
        const value   = emailInput.value;

        if (value === '') {
            showError ? setInvalid(emailInput, errorEl) : clearState(emailInput, errorEl);
            return false;
        }

        if (isValidEmail(value)) {
            setValid(emailInput, errorEl);
            return true;
        } else {
            setInvalid(emailInput, errorEl);
            return false;
        }
    }

    function validateNameField(showError) {
        const errorEl = document.getElementById('firstName-error');
        const value   = firstNameInput.value;

        if (value === '') {
            showError ? setInvalid(firstNameInput, errorEl) : clearState(firstNameInput, errorEl);
            return false;
        }

        if (isValidName(value)) {
            setValid(firstNameInput, errorEl);
            return true;
        } else {
            setInvalid(firstNameInput, errorEl);
            return false;
        }
    }

    emailInput.addEventListener('blur', () => validateEmailField(true));
    firstNameInput.addEventListener('blur', () => validateNameField(true));

    emailInput.addEventListener('input', () => {
        if (emailInput.getAttribute('aria-invalid') === 'true' || emailInput.classList.contains('border-green-500')) {
            validateEmailField(true);
        }
    });

    firstNameInput.addEventListener('input', () => {
        if (firstNameInput.getAttribute('aria-invalid') === 'true' || firstNameInput.classList.contains('border-green-500')) {
            validateNameField(true);
        }
    });

    form.addEventListener('submit', function (e) {
        const emailOk = validateEmailField(true);
        const nameOk  = validateNameField(true);

        if (!emailOk || !nameOk) {
            e.preventDefault();
            if (!emailOk) shake(emailInput);
            if (!nameOk)  shake(firstNameInput);

            const firstInvalid = !emailOk ? emailInput : firstNameInput;
            firstInvalid.focus();
        }
    });
})();

// Enable general HMR
if (import.meta.hot) {
    import.meta.hot.accept();
}
